<template lang='pug'>
    div
        ElectricalPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                    h1.product-title TEV-CP
                    h2.product-subtitle Transient Earth Voltage (TEV) PD Sensor for MV Switchgear

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                            img( src='@/assets/photos/TEVSensor.png', width="50%", alt='PD Sensor TEV-CP', title='PD Sensor TEV-CP')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Non-contact PD sensor
                                li For retrofit at MV switchgears
                                li Bandwidth: 2 MHz … 200 MHz
                                li Easy to install with integrated magnets
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet TEV-CP.pdf")
                            Maillink(to='support@bss-hs.de', sub='TEV-CP', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/PDM-600", text='Partial Discharge Monitoring System PDM-600')
                            Sitelink(to="/en/products/pdm-80", text='Partial Discharge Monitoring System PDM-80')
                            Sitelink(to="/en/products/PDM-600-Mobile", text='PDM-600-Mobile')

            section.margin-bottom
                p Capacitive sensor for partial discharge measurement on medium-voltage switchgear and other equipment in housings or with enclosures. The sensor is mounted externally on the enclosure / housing by a magnet holder and is able to detect internal partial discharges. The TEV measuring principle is based on the high-frequency propagation of PD currents across the surface of the housing. For measurements on non-magnetic housings, a tension belt can be used.


        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title TEV-CP
                h2.product-subtitle "Transient Earth Voltage" Sensor zur TE-Messsung an Mittelspannungsschaltanlagen

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                            img( src='@/assets/photos/TEVSensor.png', width="50%", alt='TE-Sensor TEV-CP', title='TE-Sensor TEV-CP')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Kontaktloser TE-Sensor
                                li Zur Nachrüstung an Mittelspannungsschaltanlagen
                                li Bandbreite: 2 MHz … 200 MHz
                                li Einfache Installation durch integrierte Magnete
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet TEV-CP.pdf")
                            Maillink(to='support@bss-hs.de', sub='TEV-CP', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/PDM-600", text='Partial Discharge Monitoring System PDM-600')
                            Sitelink(to="/de/products/pdm-80", text='Partial Discharge Monitoring System PDM-80')
                            Sitelink(to="/de/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        
            section.margin-bottom
                p Kapazitiver Sensor für die Messung von Teilentladungen an Mittelspannungsschaltanlagen und anderen Betriebsmitteln in Schaltschränken oder mit Gehäuse. Der Sensor wird außen auf dem Schaltschrank/Gehäuse per Magnethalterung angebracht und detektiert innere Teilentladungen. Das TEV-Messprinzip beruht auf der hochfrequenten Ausbreitung von TE-Strömen über die Oberfläche des Gehäuses. Für die Messung an Gehäusen, die nicht magnetische sind, kann ein Spanngurt verwendet werden.
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | TEV-CP",
            description:
                "Transient Earth Voltage Sensor zur TE-Messsungan Mittelspannungsschaltanlagen",
        },
        en: {
            title: "BSS | TEV-CP",
            description:
                "Transient Earth Voltage (TEV) PD Sensor for MV Switchgear",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>